import { DEFAULT_LOCALE, LOCALE_INTL_TAGS } from '../locales.js';
import { as } from './as.js';
import { en } from './en.js';
export { as, en };
export const dictionaries = { as, en };
/**
 * Returns a translate function bound to a locale.
 *
 * No i18n library, per the lightweight brief in phases.md §1.15 — two locales and a typed
 * dictionary need interpolation and nothing else. `{name}` placeholders are replaced;
 * an unknown key is impossible at compile time and falls back to the key at runtime, so a
 * bad dynamic lookup shows up as a visible key rather than an empty space.
 */
export function createTranslator(locale) {
    const dict = dictionaries[locale] ?? dictionaries[DEFAULT_LOCALE];
    return (key, vars) => {
        const template = dict[key] ?? key;
        if (!vars)
            return template;
        return template.replace(/\{(\w+)\}/g, (match, name) => {
            const value = vars[name];
            return value === undefined ? match : formatValue(value, locale);
        });
    };
}
/**
 * Numbers go through `Intl`, which matters more here than it looks: Assamese renders
 * digits in Bengali numerals (৫ মিনিটৰ পাঠ, not 5), exactly as the supplied design does.
 */
function formatValue(value, locale) {
    return typeof value === 'number'
        ? new Intl.NumberFormat(LOCALE_INTL_TAGS[locale]).format(value)
        : value;
}
//# sourceMappingURL=index.js.map